import React, { useState } from 'react'
import { Button, Modal } from '@which/seatbelt'
import { MagnifierPlusIcon } from '@which/seatbelt/src/components/Icons/Navigational'
import { dynamicGa4DataLayerPush } from '@which/shared'

import styles from './TableModalWrapper.module.scss'

type Props = {
  renderContent: () => React.ReactNode
  expandButtonLabel?: string
  trackingComponent?: string
}

export const TableModalWrapper: React.FC<Props> = ({
  renderContent,
  expandButtonLabel = 'Expand table',
  trackingComponent = 'Table',
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const expandTable = () => {
    trackExpandTableClick(trackingComponent, expandButtonLabel)

    setModalOpen(true)

    if (trackingComponent === 'Table') {
      const loadDynSquirrelEvent = new Event('LoadDynSquirrel', { bubbles: true, cancelable: true })
      document.dispatchEvent(loadDynSquirrelEvent)
    }
  }

  const closeModalHandler = () => {
    setModalOpen(false)
  }

  return (
    <div>
      {modalOpen && (
        <Modal renderFullScreen={true} closeModal={closeModalHandler}>
          {renderContent()}
        </Modal>
      )}

      <div className={styles.expandButtonWrapper}>
        <Button onClick={expandTable} appearance="secondary">
          <MagnifierPlusIcon width={16} height={16} />
          {expandButtonLabel}
        </Button>
      </div>

      {renderContent()}
    </div>
  )
}

const trackExpandTableClick = (trackingComponent: string, expandButtonLabel: string): void => {
  dynamicGa4DataLayerPush({
    event: 'click_expandTable_button',
    item_group: trackingComponent,
    item_text: expandButtonLabel,
  })
}
